export default __webpack_public_path__ + "static/media/me-icon-active.8a2684e2.webp";